import React from "react";
import "./atom-marquee.css";

const AtomMarquee: React.FC = () => {
  // Words used in the marquee
  const words = [
    "SMART CONTRACT",
    "SECURITY",
    "WALLETS",
    "SERVICE",
    "EVM",
    "RESEARCH",
    "TOOLS & SERVICE",
  ];

  // Function to render one row
  // Content is duplicated multiple times so the loop looks infinite
  const renderRow = (direction: "left" | "right") => {
    const repeatedWords = [...words, ...words, ...words, ...words];

    return (
      <div className="atom-marquee-row">
        <div className={`atom-marquee-track atom-scroll-${direction}`}>
          {repeatedWords.map((word, index) => (
            <div key={`${word}-${index}`} className="atom-chip">
              {word}
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <section className="atom-marquee-section">
      {/* Background dots */}
      <div className="atom-bg-dots" />

      <div className="atom-marquee-mask">
        <div className="atom-marquee-container">
          {/* Row 1: left */}
          {renderRow("left")}

          {/* Row 2: right */}
          {renderRow("right")}

          {/* Row 3: left */}
          {renderRow("left")}
        </div>
      </div>
    </section>
  );
};

export default AtomMarquee;
